module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_nordland_neg.62b3fd1a.svg";